<div *ngIf="isLoading !== false" class="skeleton-container">
  <nz-skeleton nzActive="true"> </nz-skeleton>
</div>

<div nz-row class="calendar-header" *ngIf="isLoading == false">
  <div nz-row style="margin: 5px 0pc 0px 0px">
    <!-- <div nz-row> -->
    <div nz-col nzSm="24" nzLg="6">
      <nz-button-group>
        <button
          nz-button
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          nzType="primary"
        >
          <i nz-icon nzType="left"></i>{{ "Previous" | locale }}
        </button>
        <button
          nz-button
          mwlCalendarToday
          [(viewDate)]="viewDate"
          nzType="primary"
        >
          {{ "Current" | locale }}
        </button>
        <button
          nz-button
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          nzType="primary"
        >
          {{ "Next" | locale }}<i nz-icon nzType="right"></i>
        </button>
      </nz-button-group>
    </div>
    <div nz-col nzSm="24" nzLg="6">
      <p style="font-weight: 700; font-size: large">
        {{ viewDate | calendarDate: view + "ViewTitle":"en" }}
      </p>
    </div>
    <div nz-col nzSm="24" nzLg="12">
      <nz-radio-group [ngModel]="view">
        <label
          nz-radio-button
          (click)="setView(CalendarView.Month)"
          [class.active]="view === CalendarView.Month"
          nzValue="Month"
          >{{ "Month" | locale }}</label
        >
        <label
          nz-radio-button
          (click)="setView(CalendarView.Week)"
          [class.active]="view === CalendarView.Week"
          nzValue="Week"
          >{{ "Week" | locale }}</label
        >
        <label
          nz-radio-button
          (click)="setView(CalendarView.Day)"
          [class.active]="view === CalendarView.Day"
          nzValue="Day"
          >{{ "Day" | locale }}</label
        >
      </nz-radio-group>
      <nz-space>
        <nz-space-item>
          <nz-button-group>
            <button nz-button (click)="addEvent()" nzType="primary">
              <i nz-icon nzType="star" nzTheme="twotone"></i>
              {{ "New Event" | locale }}
            </button>
          </nz-button-group>
        </nz-space-item>
      </nz-space>
      <nz-space class="btn-filter">
        <nz-space-item>
          <nz-button-group>
            <button nz-button (click)="btnFilter()" nzType="primary">
              <i nz-icon nzType="filter" nzTheme="outline"></i>
            </button>
          </nz-button-group>
        </nz-space-item>
      </nz-space>
    </div>
    <!-- </div> -->

    <div
      nz-col
      nzSpan="23"
      nzSm="23"
      nzMd="24"
      nzLg="24"
      nzXl="24"
      [hidden]="!showFilter"
    >
      <div
        nz-row
        nzSpan="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        [hidden]="!showFilter"
      >
        <div
          nz-col
          nzSpan="24"
          nzSm="24"
          nzMd="10"
          nzLg="12"
          nzXl="11"
          [hidden]="!showFilter"
        >
          <nz-space nzDirection="vertical" class="l-filter">
            <nz-card nzBorderless="true" style="min-width: 300px">
              <label style="padding: 5px">{{ "Event Type" | locale }}</label>
              <nz-select
                style="margin: 5px"
                nzMode="multiple"
                [nzPlaceHolder]="'Please select' | locale"
                [(ngModel)]="selectedActivityType"
                style="min-width: 200px"
                nzLabel="Event Type"
                (ngModelChange)="filter(CalendarView)"
              >
                <nz-option
                  *ngFor="let item of activityTypeList"
                  [nzValue]="item.id"
                  [nzLabel]="item.text"
                >
                  <!-- <i nz-icon nzType={{item.text}} nzTheme="outline"></i> -->
                  {{ item.text }}
                </nz-option>
              </nz-select>
            </nz-card>
          </nz-space>
        </div>
        <div
          nz-col
          nzSpan="24"
          nzSm="18"
          nzMd="10"
          nzLg="12"
          nzXl="12"
          [hidden]="!showFilter"
        >
          <!-- <nz-space nzDirection="vertical" class="r-filter"> -->
          <!-- <nz-card nzBorderless="true" style="min-width: 300px"> -->
          <div nz-row>
            <label nz-col nzSpan="8" style="padding: 5px">{{
              "Calendar For" | locale
            }}</label>
            <div nz-col nzSpan="16">
              <nz-select
                style="width: 100%"
                [nzCustomTemplate]="multipleTemplate"
                nzMode="multiple"
                [nzPlaceHolder]="'Please select employees' | locale"
                [(ngModel)]="selectedUsers"
                (ngModelChange)="filter(CalendarView)"
              >
                <nz-option
                  *ngFor="let item of usersList; let i = index"
                  [nzValue]="item.Code"
                  [nzLabel]="item.Name"
                >
                  <i nz-icon nzType="{{ item.text }}" nzTheme="outline"></i>
                  {{ item.text }}
                </nz-option>
              </nz-select>
            </div>
            <ng-template #multipleTemplate let-selected>
              <div
                class="ant-select-selection-item-content"
                [class]="selectedUsers | selectionStyling : selected"
              >
                <i nz-icon [nzType]="selected.nzValue"></i>
                {{ selected.nzLabel }}
              </div>
            </ng-template>
          </div>
          <!-- </nz-card> -->
          <!-- </nz-space> -->
        </div>
      </div>
    </div>

    <!-- calendar body -->

    <div
      nz-col
      class="calendarGrid"
      nzSpan="24"
      nzSm="24"
      nzMd="23"
      nzLg="23"
      nzXl="23"
      [ngSwitch]="view"
      *ngIf="isLoading == false"
    >
      <div class="more-popup scrollbar" *ngIf="moreEvents.length > 0">
        <div class="header">
          <button
            type="button"
            class="close close-more-popup"
            (click)="moreEvents = []"
          >
            &times;
          </button>
          <div class="header-day">{{ moreEvents[0].start | date: "E" }}</div>
          <div class="header-date">{{ moreEvents[0].start | date: "d" }}</div>
        </div>
        <div class="body">
          <div *ngFor="let e of moreEvents">
            <div
              class="body-events"
              [ngStyle]="{
                backgroundColor: e.color?.primary,
                color: e.color?.secondary
              }"
              (click)="handleEvent('Clicked', e)"
            >
              {{ e.titleToDisplay }}
            </div>
          </div>
        </div>
      </div>
      <ng-template
        #customCellTemplate
        let-day="day"
        let-locale="locale"
        class="cal-event"
        let-tooltipPlacement="tooltipPlacement"
        let-highlightDay="highlightDay"
        let-unhighlightDay="unhighlightDay"
        let-eventClicked="eventClicked"
        let-tooltipTemplate="tooltipTemplate"
        let-trackByEventId="trackByEventId"
        let-tooltipAppendToBody="tooltipAppendToBody"
        let-tooltipDelay="tooltipDelay"
      >
        <div class="cal-cell-top" (dblclick)="onDoubleClick(day)">
          <span class="cal-day-number">
            {{ day.date | calendarDate: "monthViewDayNumber":"en" }}</span
          >
        </div>

        <div *ngIf="day.events.length > 0" style="min-height: 65px">
          <div
            *ngFor="
              let event of day.events;
              trackBy: trackByEventId;
              index as i
            "
            (mouseenter)="highlightDay.emit({ event: event })"
            (mouseleave)="unhighlightDay.emit({ event: event })"
            (click)="
              $event.stopPropagation(); eventClicked.emit({ event: event })
            "
            mwlDraggable
            [class.cal-draggable]="event.draggable"
            [dropData]="{ event: event }"
            [dragAxis]="{ x: event.draggable, y: event.draggable }"
          >
            <ng-template
              *ngIf="i < EVENT_LIMIT; then showEventsBlock; else showMoreBlock"
            >
            </ng-template>
            <ng-template #showEventsBlock>
              <div
                class="cal-events {{ event.className | classDistributer }}"
                *ngIf="i < EVENT_LIMIT"
                [ngStyle]="{
                  backgroundColor: event.color?.primary,
                  color: event.color?.secondary
                }"
                [ngClass]="event.className"
                (mwlClick)="eventClicked.emit({ event: event })"
                [mwlCalendarTooltip]="
                  event.title | calendarEventTitle: 'monthTooltip':event
                "
                [tooltipPlacement]="tooltipPlacement"
                [tooltipEvent]="event"
                [tooltipTemplate]="tooltipTemplate"
                [tooltipAppendToBody]="tooltipAppendToBody"
                [tooltipDelay]="tooltipDelay"
              >
                <span class="l-day-view">
                  {{ event.titleToDisplay }}
                </span>
                <br />
                <span>
                  {{ event.BPName }}
                </span>
                <span class="sm-day-view">*</span>
              </div>
            </ng-template>
            <ng-template #showMoreBlock>
              <ng-container *ngIf="i === EVENT_LIMIT">
                <div
                  class="cal-events-more"
                  (mwlClick)="handleMoreEvent($event, day.events)"
                >
                  <a class="showmore">
                    {{ day.events.length - EVENT_LIMIT }}
                    {{ "more" | locale }}</a
                  >
                </div>
              </ng-container>
            </ng-template>
          </div>
        </div>
      </ng-template>
      <mwl-calendar-month-view
        *ngSwitchCase="CalendarView.Month"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"
        (dayClicked)="dayClicked($event.day)"
        (eventClicked)="handleEvent('Clicked', $event.event)"
        (eventTimesChanged)="eventTimesChanged($event)"
        (beforeViewRender)="updateCalendarEvents($event)"
        [locale]="language"
        [cellTemplate]="customCellTemplate"
      >
        <!-- [cellTemplate]="customCellTemplate" -->
      </mwl-calendar-month-view>
      <mwl-calendar-week-view
        *ngSwitchCase="CalendarView.Week"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"
        (eventClicked)="handleEvent('Clicked', $event.event)"
        (eventTimesChanged)="eventTimesChanged($event)"
        (beforeViewRender)="updateCalendarEvents($event)"
        [locale]="language"
        (hourSegmentClicked)="saveDateAfterFirstClick($event)"
      >
      </mwl-calendar-week-view>
      <mwl-calendar-day-view
        *ngSwitchCase="CalendarView.Day"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"
        (eventClicked)="handleEvent('Clicked', $event.event)"
        (eventTimesChanged)="eventTimesChanged($event)"
        (beforeViewRender)="updateCalendarEvents($event)"
        (hourSegmentClicked)="saveDateAfterFirstClick($event)"
        [locale]="language"
      >
      </mwl-calendar-day-view>
    </div>
  </div>

  <div
    nz-row
    [ngSwitch]="view"
    style="background-color: #f9f9f9; max-height: 70vh"
    *ngIf="isLoading == false"
  >
    <div class="day-events">
      <p class="day-event-header">
        {{ dayEventDate | date: "EEEE, MMMM d, y" | locale }}
      </p>
      <nz-space-item style="min-height: 260px; width: 100% !important">
        <nz-space
          style="
            width: 100% !important;
            padding: 0px;
            margin-left: 0px;
            margin-left: auto;
            font-size: large;
          "
        >
          <nz-space-item
            style="width: 100% !important; padding: 0px; margin-left: 0px"
          >
            <div style="min-height: 260px">
              <nz-list
                style="
                  min-height: 260px;
                  width: 100% !important;
                  max-height: 550px;
                  height: 90%;
                "
                [nzDataSource]="this.dayEvent"
                [nzRenderItem]="item"
                [nzItemLayout]="'horizontal'"
                class="records-list-comm"
              >
                <nz-list-item>
                  <nz-skeleton
                    *ngIf="false"
                    [nzAvatar]="true"
                    [nzParagraph]="{ rows: 1 }"
                  ></nz-skeleton>
                  <ng-template #item let-item>
                    <nz-comment
                      [nzAuthor]="item.AttendTo"
                      nzDatetime="{{ item.start | date }} - {{
                        item.end | date
                      }}"
                      class="CalendarComment"
                    >
                      <nz-avatar
                        nz-comment-avatar
                        alt="phone"
                        *ngIf="item.icon == 'phone'"
                        nzIcon="phone"
                        style="margin: auto"
                      ></nz-avatar>
                      <nz-avatar
                        nz-comment-avatar
                        *ngIf="item.icon == 'smile-o'"
                        nzIcon="deployment-unit"
                        style="margin: auto"
                      ></nz-avatar>
                      <nz-avatar
                        nz-comment-avatar
                        *ngIf="item.icon == 'thumb-tack'"
                        nzIcon="unordered-list"
                        style="margin: auto"
                      ></nz-avatar>
                      <nz-avatar
                        nz-comment-avatar
                        *ngIf="item.icon == 'send'"
                        nzIcon="mail"
                        style="margin: auto"
                      >
                      </nz-avatar>
                      <nz-avatar
                        nz-comment-avatar
                        *ngIf="item.icon == 'E'"
                        nzIcon="book"
                        style="margin: auto"
                      >
                      </nz-avatar>
                      <div
                        nzIcon="fund-view"
                        style="margin-left: -15px"
                        *ngIf="
                          item.Action == 'send' && item.U_ITM_BWEB_READ === 'Y'
                        "
                      >
                        <nz-badge
                          style="margin-right: auto"
                          [nzCount]="item.U_ITM_BWEB_CREAD"
                        >
                          <button
                            nz-button
                            nz-dropdown
                            [nzDropdownMenu]="menu"
                            class="email-not-badge"
                            nzClickHide="false"
                            nzTrigger="hover"
                            nzPlacement="bottomRight"
                          >
                            <i nz-icon nzType="eye" nzTheme="outline"></i>
                          </button>
                        </nz-badge>
                        <nz-dropdown-menu #menu="nzDropdownMenu">
                          <ul nz-menu>
                            <li nz-menu-item>
                              <h2>{{ "Viewed At" | locale }}</h2>
                            </li>
                            <li
                              nz-menu-item
                              *ngFor="
                                let item of item.U_ITM_BWEB_DREAD.split(';')
                              "
                            >
                              <nz-tag [nzColor]="'green'" *ngIf="item !== ''">{{
                                item
                              }}</nz-tag>
                            </li>
                          </ul>
                        </nz-dropdown-menu>
                      </div>

                      <nz-comment-content>
                        <ng-container>
                          <div style="margin: 2px">
                            <div class="ActivityContainer">
                              <div class="activityHeader">
                                <!-- <span>{{ item.AttendTo }}</span
                                ><br /> -->
                                <span>
                                  <i class="fas fa-user-tie"></i>
                                  {{ item.BPName }}</span
                                >
                              </div>
                              <div class="activityDetails">
                                <i class="fas fa-quote-left"></i>
                                {{ item.title }}
                              </div>
                            </div>
                            <div style="display: inline-block">
                              <nz-tag
                                style="margin: 5px"
                                *ngIf="item.AttendEmpl !== ' '"
                                >{{ item.AttendEmpl }}</nz-tag
                              >
                            </div>
                          </div>
                        </ng-container>
                        <nz-button-group class="activity-list-edit-btn">
                          <a
                            nz-button
                            nzType="link"
                            (click)="navigateTo(25, item.id)"
                            ><i nz-icon nzType="edit" nzTheme="outline"></i
                          ></a>
                        </nz-button-group>
                        <p>{{ item.ClgCode }}</p>
                        <p>{{ item.OprLine }}</p>
                        <p>{{ item.Recontact }}</p>
                        <p>{{ item.endDate }}</p>
                        <p>{{ item.U_ITM_ACT_GUID }}</p>
                        <p>{{ item.U_ITM_BWEB_CREAD }}</p>
                        <p>{{ item.U_ITM_BWEB_DREAD }}</p>
                        <p>{{ item.U_ITM_BWEB_EML_BCC }}</p>
                        <p>{{ item.U_ITM_BWEB_EML_CC }}</p>
                        <p>{{ item.U_ITM_BWEB_EML_TO }}</p>
                        <p>{{ item.U_ITM_BWEB_READ }}</p>

                        <p>{{ item.U_ITM_BWEB_EML_TO }}</p>
                      </nz-comment-content>
                      <!--<nz-comment-action style="display: inline-block; margin: 5px;">Reply to</nz-comment-action> -->
                    </nz-comment>
                    <nz-divider></nz-divider>
                  </ng-template>
                </nz-list-item>
              </nz-list>
            </div>
          </nz-space-item>
        </nz-space>
      </nz-space-item>
    </div>
  </div>

  <div nz-row nzJustify="space-around" *ngIf="isLoading == false"></div>
</div>
